import axios from "axios"
var domain = "https://samalot.dev";

export var http = {

  post ( url, data, successCb = null, errorCb = function() {} ) {
    axios( { method: "post", url: domain + url, data: data } )
    .then( successCb )
    .catch( function( err ) {
      if ( err.response && err.response.data && err.response.data.message ) {
        // s2s_store.commit( "addError", err.response.data.message );
      }
      errorCb;
    });

  },

  /* The init function is called on creation and is used to setup the interceptors */
  init () {

    /* Intercept outgoing requests */
    axios.interceptors.request.use(
      function( config ) {
        return config;
      }
    );

    /* Intercept incoming requests */
    axios.interceptors.response.use(
      function( response ) {

        /* If there is an error, reject the request - the message is displayed to the user. */
        if( response.status > 399 ) { return Promise.reject( response.data.message ); }
        return response;
      },

      /* Fallback error handling, reject the request */
      function( error ) { return Promise.reject( error ); }
    );

  }

}
